import { useState } from "react";
import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import { Skeleton } from "@babackapp/ui/components/skeleton";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@babackapp/ui/components/accordion";
import ActivityWrapper from "./activity-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import ActivityContentWrapper from "./activity-content-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import { useEventProperties } from "./use-event-properties";
import useTranslation from "@babackapp/translations/use-translation";
import klaviyoLogo from "@/assets/integrations/klaviyo-logo.png";

// On ne traduit pas les eventName, ils sont déjà explicites

type KlaviyoActivityProps = {
  activity: ReturnRequestLogDto;
  returnRequestId: string;
};

export default function KlaviyoActivity({
  activity,
  returnRequestId,
}: KlaviyoActivityProps) {
  const params = activity.params as {
    eventName: string;
  };
  const t = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { eventProperties, isLoading, isError } = useEventProperties(
    activity,
    returnRequestId,
    isOpen,
  );
  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <img src={klaviyoLogo} className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2 flex-1 justify-between w-full">
          <Accordion
            type="single"
            collapsible
            className="flex-1"
            onValueChange={(value) => setIsOpen(!!value)}
          >
            <AccordionItem value="item-1" className="border-0">
              <AccordionTrigger className="p-0 w-full">
                <ActivityItemHeader
                  title=""
                  timestamp={activity.date}
                  description={null}
                >
                  <div className="flex flex-col gap-0">
                    <div className="flex items-center gap-2">
                      <span>Klaviyo</span>
                      <span className="font-normal text-xs underline">
                        {params.eventName}
                      </span>
                    </div>
                  </div>
                </ActivityItemHeader>
              </AccordionTrigger>
              <AccordionContent>
                {isLoading ? (
                  <Skeleton className="mt-2 h-16 w-full" />
                ) : isError ? (
                  <div className="mt-2 text-xs text-destructive">
                    {t("misc.error")}
                  </div>
                ) : (
                  eventProperties && (
                    <pre className="mt-2 rounded-md bg-muted p-4 text-xs overflow-x-auto whitespace-pre-wrap">
                      {eventProperties}
                    </pre>
                  )
                )}
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
